import React from "react";
import { ArrowUpRight } from "lucide-react";
import { STATS, SUBSTACK_URL } from "../../mock/mock";

const ACCENT_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/nmcvuo22_pexels-giancarlo-principe-outdoor-adventures-2158906038-35743120.webp";

const AccentBlock = () => {
  const bannerItems = Array.from({ length: 18 });
  return (
    <section className="bg-[#FFFDF6]">
      <div className="py-20 md:py-28 max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          className="rounded-[2rem] md:rounded-[2.5rem] p-8 md:p-16 relative overflow-hidden"
          style={{ background: "#C1D3D9" }}
        >
          <div className="grid md:grid-cols-12 gap-10 md:gap-12 items-center">
            <div className="md:col-span-6 om-fade-up">
              <h2 className="font-serif-display text-[#41232E] text-4xl md:text-6xl leading-[1.02] tracking-[-0.02em]">
                Clarity.
                <br />
                Choice.
                <br />
                Freedom.
              </h2>
              <p className="mt-8 text-[#41232E]/85 text-lg leading-relaxed max-w-md">
                The Owner&rsquo;s Mind translates what highly effective people do into practical
                ideas everyday readers can borrow — for setting goals, thinking through decisions,
                and creating options in their own life.
              </p>
              <a
                href={SUBSTACK_URL}
                target="_blank"
                rel="noreferrer"
                className="mt-8 inline-flex items-center gap-2 om-btn om-btn-primary"
              >
                Start reading <ArrowUpRight size={16} />
              </a>
            </div>

            <div className="md:col-span-6 om-fade-up">
              <div
                className="rounded-[1.5rem] overflow-hidden aspect-[4/5] md:aspect-[5/6] bg-[#c7bca0] shadow-[0_10px_30px_rgba(65,35,46,0.15)]"
              >
                <img
                  src={ACCENT_IMG}
                  alt="Editorial lifestyle"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Stats row underneath the card */}
        <div className="grid md:grid-cols-3 gap-10 md:gap-14 mt-14 md:mt-20 px-2 md:px-6">
          {STATS.map((s, i) => (
            <div key={i} className="om-fade-up" style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="font-serif-display text-[#41232E] text-6xl md:text-7xl leading-none mb-4">
                {s.figure}
              </div>
              <p className="text-[#41232E]/80 leading-relaxed max-w-xs mb-3">{s.label}</p>
              <div className="text-[0.78rem] tracking-wide text-[#605F26] underline decoration-[#605F26]/40 underline-offset-4">
                {s.source}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccentBlock;
